import {environment} from '../../environments/environment';
import {Injectable} from '@angular/core';
import {HttpHeaders} from '@angular/common/http';
import {FormatService} from '../service/format/service-format';
import {ExecException} from 'child_process';
import {PdfShowComponent} from '../views/info/view/pdf.component';
import {BsModalService} from 'ngx-bootstrap/modal';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {DatePipe} from '@angular/common';
import {DocviewComponent} from '../views/info/view/docview.component';
@Injectable({
  providedIn: 'root'
})
export class CommandUtil
{
  @BlockUI() blockUI: NgBlockUI;
  public static chuaPhoCap: number = 0;
  public static daPhoCap: number = 1;
  public static defaultValue: number = -1;
  public  chuaXem: number = 0;
  public  daXem: number = 1;
  public  chuaXemYKien: number = 2;
  public  daXemYKien: number = 3;
  public startAction()
  {
    this.blockUI.start('Hệ thống đang xử lý dữ liệu. Vui lòng chờ trong giây lát');
  }
  public stopAction()
  {
    this.blockUI.stop();
  }
  constructor(
    private bsModalService: BsModalService,
    private datePipe: DatePipe
  ){
  }
  public convertDateTime(value: Date): string
  {
    return this.datePipe.transform(value, 'dd/MM/yyyy HH:mm:ss');
  }
  public removeItem(element: number, dataCheck: Object[]) {
    dataCheck.forEach((value, index) => {
      if(value == element) dataCheck.splice(index,1);
    });
  }
  public openPdf(folder: string, fileName: string, fileType: string, title: string)
  {
    if (fileType === 'application/pdf') {
      const modalEdit = this.bsModalService.show(PdfShowComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
      (<PdfShowComponent>modalEdit.content).show(
        this.getUrlDownload(folder, fileName, fileType, title)
      );
      (<PdfShowComponent>modalEdit.content).onClose.subscribe(result => {
        if (result === true) {
          return false;

        }
      });
    }else
      window.open( this.getUrlDownload(folder, fileName, fileType, title), '_blank');
  }
  public getUrlDownload(folder: string, fileName: string, fileType: string, title: string): string
  {
      return environment.downloadURL + `file=${folder}${fileName}&type=${fileType}&title=${title}&auth=Bearer ${sessionStorage.getItem('token')}`;
  }

  public getUrlAvatar(file: string): string
  {
    if(file===null)
      return 'assets/img/avatars/1.jpg';
    return environment.downloadURL + `file=${file}&type=image/jpg&title=avatar&auth=Bearer ${sessionStorage.getItem('token')}`;
  }
  public getDate(strDate : string)
  {
    try {
      let arr : string[] = strDate.split('/');
      if(arr.length>=3)
        return new Date(Date.parse(arr[1]+"/"+arr[0]+"/"+arr[2]));
    }catch(e)
    {

    }

    return new Date();
  }
  public getSizeFile(size: number): string
  {
    let iSize = (size / 1024);
    iSize = (Math.round(iSize * 100) / 100);
    return iSize  + "KB";
  }
  public formatAlert(first: string , last: string, value: string ): string
  {
    let temp: string = value;
    if (first !== null && first !== '')
      temp =  first;
    if (last !== null && last !== '')
      temp =  temp + ' - ' + last;
    return temp;
  }
  public zipFiles(fileName: string, url: Object []) : string {

    let pathFile  = "";
    let nameFile  = "";
    let titleFile = "";
    for(let i = 0 ; i < url.length ; i++)
    {
      pathFile += url[i]["folder"] + ',';
      nameFile += url[i]["fileKey"] +',';
      titleFile += url[i]["name"] +',';
    }
    return environment.downloadZipURL + `pathfile=${pathFile}&filename=${nameFile}&filetitle=${titleFile}&title=${fileName}&auth=Bearer ${sessionStorage.getItem('token')}`;
  }

  public zipCalendarNewsFiles(ids: String, fileName: String) : string {

    return environment.downloadZipCalendarNewsURL + `ids=${ids}&title=${fileName}&auth=Bearer ${sessionStorage.getItem('token')}`;
  }
  public hightlineString(content: string, value: string): string
  {
    if(value !== '') {
      return content.replace(new RegExp(value.trim(), "gi"), match => {
        return '<span style="background-color:yellow;color:black;border-radius:5px; padding:1px;">' + match + '</span>';
      });
    }
    return content;

  }
  public  viewFile(bsModalService: BsModalService, folder: string, fileName: string, fileType: string, title: string)
  {
    const modalEdit = bsModalService.show(DocviewComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<DocviewComponent>modalEdit.content).show(
      environment.downloadURL + `file=${folder}${fileName}&type=${fileType}&title=${title}&auth=Bearer ${sessionStorage.getItem('token')}`,
      title
    );
    (<DocviewComponent>modalEdit.content).onClose.subscribe(result => {

    });
  }
  public viewMultifiles(bsModalService: BsModalService,  url: Object [])  {
    const dataFiles: Object[] = [];
    for (let i = 0; i < url.length; i++) {
      dataFiles.push({
        type: url[i]['width'],
        name: url[i]['name'],
        url:  this.getUrlDownload(url[i]['folder'], url[i]['fileKey'], url[i]['width'], url[i]['name'])
      });
    }
    const modalEdit = bsModalService.show(DocviewComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<DocviewComponent>modalEdit.content).showMulti(
      dataFiles
    );
    (<DocviewComponent>modalEdit.content).onClose.subscribe(result => {

    });
  }
}
